import { useDetectGPU } from '@react-three/drei'
import { Bloom, EffectComposer, Outline, ToneMapping } from '@react-three/postprocessing'
import { DepthPass, OutlineEffect, ToneMappingMode } from 'postprocessing'
import { useRef } from 'react'

import { useOutlineDepthExclusion } from '@hooks'
import { usePostProcessingControls } from '@utils'

interface OutlineEffectInternal extends OutlineEffect {
  depthPass?: DepthPass
}

export function PostProcessing() {
  const { enabled, bloom, outline } = usePostProcessingControls()

  const { tier } = useDetectGPU()
  const outlineRef = useRef<OutlineEffectInternal>(null)
  useOutlineDepthExclusion(outlineRef)

  if (!enabled) return null

  return (
    <EffectComposer multisampling={0} autoClear={false}>
      {bloom && tier >= 2 ? (
        <Bloom mipmapBlur levels={2} intensity={1} luminanceThreshold={2} />
      ) : (
        <></>
      )}
      {outline ? (
        <Outline
          ref={outlineRef}
          edgeStrength={5}
          visibleEdgeColor={0xffffff}
          hiddenEdgeColor={0xffffff}
        />
      ) : (
        <></>
      )}
      <ToneMapping mode={ToneMappingMode.ACES_FILMIC} />
    </EffectComposer>
  )
}
